module.exports = __webpack_public_path__ + "img/5.02.8c987528.jpg";